import './LogErrorMarker.css';

const ERROR_CHUNK_MAGIC_CODE = '999';
const LOG_VIEWER_ERROR_MARKER_CLASS = 'log-viewer__error-marker';
const LOG_VIEWER_ERROR_MARKER_ANIMATION_CLASS = 'log-viewer__animate-error';

const SCROLL_TIMEOUT = 50;
const waitForScrollEnd = (callback: VoidFunction, waitTimeout = SCROLL_TIMEOUT) => {
  let timeoutId: number = window.setTimeout(() => callback(), waitTimeout);

  const onScroll = () => {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      window.removeEventListener('scroll', onScroll);
      callback();
    }, waitTimeout);
  };

  window.addEventListener('scroll', onScroll);
};

function createErrorMarker() {
  return `<span class="${LOG_VIEWER_ERROR_MARKER_CLASS}"></span>`;
}

function getErrorMarkers(container: Element | null) {
  return container?.getElementsByClassName(LOG_VIEWER_ERROR_MARKER_CLASS);
}

function getErrorMarkerCount(container: Element | null) {
  return container?.querySelectorAll(`.${LOG_VIEWER_ERROR_MARKER_CLASS}`)?.length || 0;
}

function jumpToError(container: Element | null, index: number) {
  const markers = getErrorMarkers(container);
  if (!markers?.length) {
    return;
  }

  // Stop animation for all markers
  Array.from(markers).forEach((marker) => marker.classList.remove(LOG_VIEWER_ERROR_MARKER_ANIMATION_CLASS));
  // Scroll to the marker
  markers.item(index)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // Animate the marker after the scroll is finished
  waitForScrollEnd(() => {
    markers.item(index)?.classList.add(LOG_VIEWER_ERROR_MARKER_ANIMATION_CLASS);
  });
}

export { createErrorMarker, ERROR_CHUNK_MAGIC_CODE, getErrorMarkerCount, jumpToError };
